export function isServiceWorkerSupported() {
    return typeof navigator !== 'undefined' && 'serviceWorker' in navigator;
}
//# sourceMappingURL=isServiceWorkerSupported.js.map